<template>
  <div>
    <div class="search">
      <el-form :inline="true" :model="curform">
        <el-row>
          <el-col :span="24" class="key-word">
            <el-form-item label="关键字:">
              <el-input v-model="curform.keyWord"></el-input>
            </el-form-item>
              <el-form-item>
              <span class="searh-btn" @click="searchCustomer">
                <i class="el-icon-search"></i>查询
              </span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div>
      <el-divider class="divider"></el-divider>
      <el-table class="m-table" :data="tableData" style="width: 100%" stripe>
        <!-- <el-table-column prop="id" label="机构id"> </el-table-column> -->
        <el-table-column prop="epName" label="客户名称"> </el-table-column>
        <el-table-column prop="contact" label="联系人"> </el-table-column>
        <el-table-column prop="mobile" label="手机号"> </el-table-column>
        <el-table-column prop="userType" label="主体类型">
          <template slot-scope="scope">
            <span>{{ subjectType[scope.row.userType]}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="注册时间"> </el-table-column>
        <el-table-column fixed="right" label="操作" width="120px">
          <template slot-scope="scope">
            <el-button @click="agentCustomDetail(scope.row)" type="text">
              详情</el-button
            >
          </template>
        </el-table-column>
        <!-- <el-table-column prop="level" label="已存证量级"> </el-table-column>
        <el-table-column prop="accumulated " label="累计返佣（元）">
        </el-table-column> -->
        <!-- <el-table-column
          prop="proportion"
          label="返佣比例（百分比）"
          width="280"
        >
        </el-table-column> -->
        <!-- <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button @click="setItem(scope.row)" type="text" size="small"
              >返佣设置</el-button
            >
          </template>
        </el-table-column> -->
      </el-table>
      <!-- <el-dialog title="返佣设置" :visible.sync="dialogFormVisible">
        <el-form :model="form">
          <el-form-item label="返佣比例" :label-width="formLabelWidth">
            <el-input placeholder="%" v-model="form.proportion" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogFormVisible = false"
            >确 定</el-button
          >
        </div>
      </el-dialog> -->
      <Pagination
        :total="total"
        :pageSize="pageSize"
        :pageSizes="pageSizes"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        :currentPage="currentPage"
      ></Pagination>
    </div>
  </div>
</template>
<script>
import Pagination from "@/components/common/Pagination.vue";
import Api from "@/api";
import { statusCode } from '@/config'
import { setStorageItem, getStorageItem, removeStorageItem } from "@/utils";
export default {
  name: "AgentCustomersList",
  components: { Pagination },
  data() {
    return {
      // form: {
      curform: {
        keyWord: "",
      },
      subjectType:{
        1:"法人",
        2:"自然人"
      },
      tableData:[],
      params: {
        epName:"", // 关键字查询
        count: "5", // 每⻚页展示数量量
        agentId: this.$route.query.userId, // 企业
        start: "1",// 当前所在⻚页
        isAgent:false,
        state: 0
      },
      tableLoading: false,
      total: 1, // 总条数
      pageSize: 5, // 每页显示条数
      pageSizes: ["5", "10", "20"], // 页码
      currentPage: 1, // 当前页
    };
  },

  created() {
       this.getAgentList();
  },

  methods: {
    getAgentList(){
        this.params.epName = encodeURIComponent(this.curform.keyWord);
        this.tableLoading = true;
        return Api.customer
        .customerManagementList(this.params)
        .then((res) => {
          if (res.retCode === statusCode.SUCCESS) {
            if (res.detail && res.detail.length) {
              this.$message({
                showClose: true,
                message: "查询成功",
                type: "success",
              });
            }
            this.tableData = res.detail;
            this.total = res.total;
          } else {
            this.$message.closeAll();
            this.$message({
              showClose: true,
              message: res.retMsg,
              type: "error",
            });
          }
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    agentCustomDetail(row){
      setStorageItem('epDetail', row) // 储存企业详情，用于详情页面展示
      this.$router.push({
        path:"/agent/agentCustomerDetail",
        query: {
           type:row.userType,
           from: 'manage',
           epId: row.epId,
           customerChannel: row.customerChannel,
           userType:row.userType,
           agentcustomerinfo:'agentcustomerinfo'
          }
        
      })
      console.log("代理商代理的客户详情")
    },
    //返佣设置
    // setItem(row) {
    //   this.dialogFormVisible = true;
    // },
    searchCustomer() {
      this.getAgentList();
      console.log("查询");
    },
    handleSizeChange(val) {
      //   this.pageSize = val;
      //   this.params.count = val;
      //   this.getFinaceOrder();
      this.params.count = val
      this.getAgentList()
    },
    handleCurrentChange(val) {
      //   this.currentPage = val;
      //   this.params.start = val;
      //   this.getFinaceOrder();
      this.params.start = val
      this.getAgentList()
    },
  },
};
</script>
<style lang="scss" scoped>
.searh-btn {
  display: inline-block;
  margin-left: 25px;
  width: 90px;
  height: 36px;
  line-height: 34px;
  color: #fff;
  text-align: center;
  background: linear-gradient(
    90deg,
    rgba(248, 194, 80, 1),
    rgba(246, 170, 9, 1)
  );
  box-shadow: 0px 0px 3px 0px rgba(246, 186, 58, 0.27);
  border-radius: 4px;
  border: none;
  font-weight: 500;
  font-size: 16px;
  cursor: pointer;
  i {
    margin-right: 8px;
  }
}
.search-btn-wrap {
  text-align: right;
}
.key-word {
  ::v-deep .el-form-item__content {
    width: 280px;
  }
}
.search{
  ::v-deep .el-form-item{
    margin-bottom: 0;
  }
}
</style>
